import type { CSSProperties, ReactNode } from "react";
import { Card } from "./Card.js";

/**
 * Cartão de indicador (Design.md §5.2 / §9): título + número grande + detalhe,
 * com slot livre abaixo (barras, colunas). Usado nos cards de Lead Time e
 * Total enviado da guia Gerenciar envios.
 */
export interface IndicatorCardProps {
  title: ReactNode;
  value: ReactNode;
  detail?: ReactNode;
  children?: ReactNode;
  style?: CSSProperties;
}

export function IndicatorCard({
  title,
  value,
  detail,
  children,
  style
}: IndicatorCardProps): ReactNode {
  return (
    <Card {...(style !== undefined ? { style } : {})}>
      <div
        style={{
          fontSize: 11,
          fontWeight: 700,
          letterSpacing: "0.04em",
          textTransform: "uppercase",
          color: "var(--text-muted)"
        }}
      >
        {title}
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "baseline",
          gap: "0.5rem",
          marginTop: "0.35rem"
        }}
      >
        <span style={{ fontSize: 30, fontWeight: 700, lineHeight: 1.1 }}>
          {value}
        </span>
        {detail !== undefined ? (
          <span style={{ fontSize: 12.5, color: "var(--text-muted)" }}>
            {detail}
          </span>
        ) : null}
      </div>
      {children !== undefined ? (
        <div style={{ marginTop: "0.9rem" }}>{children}</div>
      ) : null}
    </Card>
  );
}
